/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedDailymenuImport } from './routes/_authenticated/_dailymenu'
import { Route as AuthenticatedItemsIndexImport } from './routes/_authenticated/items/index'
import { Route as AuthenticatedOrdersLayoutImport } from './routes/_authenticated/orders/_layout'
import { Route as AuthenticatedOrdersLayoutIndexImport } from './routes/_authenticated/orders/_layout/index'
import { Route as AuthenticatedDailymenuDailymenuIndexImport } from './routes/_authenticated/_dailymenu/dailymenu/index'
import { Route as AuthenticatedOrdersLayoutReadyImport } from './routes/_authenticated/orders/_layout/ready'
import { Route as AuthenticatedOrdersLayoutNewImport } from './routes/_authenticated/orders/_layout/new'
import { Route as AuthenticatedOrdersLayoutDeliveredImport } from './routes/_authenticated/orders/_layout/delivered'
import { Route as AuthenticatedItemsDetailIdImport } from './routes/_authenticated/items/detail/$id'
import { Route as AuthenticatedDailymenuDailymenuTodayImport } from './routes/_authenticated/_dailymenu/dailymenu/today'
import { Route as AuthenticatedDailymenuDailymenuNewImport } from './routes/_authenticated/_dailymenu/dailymenu/new'
import { Route as AuthenticatedDailymenuDailymenuDayImport } from './routes/_authenticated/_dailymenu/dailymenu/day'

// Create Virtual Routes

const AuthenticatedOrdersImport = createFileRoute('/_authenticated/orders')()

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedOrdersRoute = AuthenticatedOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSettingsRoute = AuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedDailymenuRoute = AuthenticatedDailymenuImport.update({
  id: '/_dailymenu',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedItemsIndexRoute = AuthenticatedItemsIndexImport.update({
  id: '/items/',
  path: '/items/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOrdersLayoutRoute = AuthenticatedOrdersLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthenticatedOrdersRoute,
} as any)

const AuthenticatedOrdersLayoutIndexRoute =
  AuthenticatedOrdersLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrdersLayoutRoute,
  } as any)

const AuthenticatedDailymenuDailymenuIndexRoute =
  AuthenticatedDailymenuDailymenuIndexImport.update({
    id: '/dailymenu/',
    path: '/dailymenu/',
    getParentRoute: () => AuthenticatedDailymenuRoute,
  } as any)

const AuthenticatedOrdersLayoutReadyRoute =
  AuthenticatedOrdersLayoutReadyImport.update({
    id: '/ready',
    path: '/ready',
    getParentRoute: () => AuthenticatedOrdersLayoutRoute,
  } as any)

const AuthenticatedOrdersLayoutNewRoute =
  AuthenticatedOrdersLayoutNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedOrdersLayoutRoute,
  } as any)

const AuthenticatedOrdersLayoutDeliveredRoute =
  AuthenticatedOrdersLayoutDeliveredImport.update({
    id: '/delivered',
    path: '/delivered',
    getParentRoute: () => AuthenticatedOrdersLayoutRoute,
  } as any)

const AuthenticatedItemsDetailIdRoute = AuthenticatedItemsDetailIdImport.update(
  {
    id: '/items/detail/$id',
    path: '/items/detail/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedDailymenuDailymenuTodayRoute =
  AuthenticatedDailymenuDailymenuTodayImport.update({
    id: '/dailymenu/today',
    path: '/dailymenu/today',
    getParentRoute: () => AuthenticatedDailymenuRoute,
  } as any)

const AuthenticatedDailymenuDailymenuNewRoute =
  AuthenticatedDailymenuDailymenuNewImport.update({
    id: '/dailymenu/new',
    path: '/dailymenu/new',
    getParentRoute: () => AuthenticatedDailymenuRoute,
  } as any)

const AuthenticatedDailymenuDailymenuDayRoute =
  AuthenticatedDailymenuDailymenuDayImport.update({
    id: '/dailymenu/day',
    path: '/dailymenu/day',
    getParentRoute: () => AuthenticatedDailymenuRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_dailymenu': {
      id: '/_authenticated/_dailymenu'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedDailymenuImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/orders': {
      id: '/_authenticated/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/orders/_layout': {
      id: '/_authenticated/orders/_layout'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthenticatedOrdersLayoutImport
      parentRoute: typeof AuthenticatedOrdersRoute
    }
    '/_authenticated/items/': {
      id: '/_authenticated/items/'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof AuthenticatedItemsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_dailymenu/dailymenu/day': {
      id: '/_authenticated/_dailymenu/dailymenu/day'
      path: '/dailymenu/day'
      fullPath: '/dailymenu/day'
      preLoaderRoute: typeof AuthenticatedDailymenuDailymenuDayImport
      parentRoute: typeof AuthenticatedDailymenuImport
    }
    '/_authenticated/_dailymenu/dailymenu/new': {
      id: '/_authenticated/_dailymenu/dailymenu/new'
      path: '/dailymenu/new'
      fullPath: '/dailymenu/new'
      preLoaderRoute: typeof AuthenticatedDailymenuDailymenuNewImport
      parentRoute: typeof AuthenticatedDailymenuImport
    }
    '/_authenticated/_dailymenu/dailymenu/today': {
      id: '/_authenticated/_dailymenu/dailymenu/today'
      path: '/dailymenu/today'
      fullPath: '/dailymenu/today'
      preLoaderRoute: typeof AuthenticatedDailymenuDailymenuTodayImport
      parentRoute: typeof AuthenticatedDailymenuImport
    }
    '/_authenticated/items/detail/$id': {
      id: '/_authenticated/items/detail/$id'
      path: '/items/detail/$id'
      fullPath: '/items/detail/$id'
      preLoaderRoute: typeof AuthenticatedItemsDetailIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/orders/_layout/delivered': {
      id: '/_authenticated/orders/_layout/delivered'
      path: '/delivered'
      fullPath: '/orders/delivered'
      preLoaderRoute: typeof AuthenticatedOrdersLayoutDeliveredImport
      parentRoute: typeof AuthenticatedOrdersLayoutImport
    }
    '/_authenticated/orders/_layout/new': {
      id: '/_authenticated/orders/_layout/new'
      path: '/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AuthenticatedOrdersLayoutNewImport
      parentRoute: typeof AuthenticatedOrdersLayoutImport
    }
    '/_authenticated/orders/_layout/ready': {
      id: '/_authenticated/orders/_layout/ready'
      path: '/ready'
      fullPath: '/orders/ready'
      preLoaderRoute: typeof AuthenticatedOrdersLayoutReadyImport
      parentRoute: typeof AuthenticatedOrdersLayoutImport
    }
    '/_authenticated/_dailymenu/dailymenu/': {
      id: '/_authenticated/_dailymenu/dailymenu/'
      path: '/dailymenu'
      fullPath: '/dailymenu'
      preLoaderRoute: typeof AuthenticatedDailymenuDailymenuIndexImport
      parentRoute: typeof AuthenticatedDailymenuImport
    }
    '/_authenticated/orders/_layout/': {
      id: '/_authenticated/orders/_layout/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthenticatedOrdersLayoutIndexImport
      parentRoute: typeof AuthenticatedOrdersLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedDailymenuRouteChildren {
  AuthenticatedDailymenuDailymenuDayRoute: typeof AuthenticatedDailymenuDailymenuDayRoute
  AuthenticatedDailymenuDailymenuNewRoute: typeof AuthenticatedDailymenuDailymenuNewRoute
  AuthenticatedDailymenuDailymenuTodayRoute: typeof AuthenticatedDailymenuDailymenuTodayRoute
  AuthenticatedDailymenuDailymenuIndexRoute: typeof AuthenticatedDailymenuDailymenuIndexRoute
}

const AuthenticatedDailymenuRouteChildren: AuthenticatedDailymenuRouteChildren =
  {
    AuthenticatedDailymenuDailymenuDayRoute:
      AuthenticatedDailymenuDailymenuDayRoute,
    AuthenticatedDailymenuDailymenuNewRoute:
      AuthenticatedDailymenuDailymenuNewRoute,
    AuthenticatedDailymenuDailymenuTodayRoute:
      AuthenticatedDailymenuDailymenuTodayRoute,
    AuthenticatedDailymenuDailymenuIndexRoute:
      AuthenticatedDailymenuDailymenuIndexRoute,
  }

const AuthenticatedDailymenuRouteWithChildren =
  AuthenticatedDailymenuRoute._addFileChildren(
    AuthenticatedDailymenuRouteChildren,
  )

interface AuthenticatedOrdersLayoutRouteChildren {
  AuthenticatedOrdersLayoutDeliveredRoute: typeof AuthenticatedOrdersLayoutDeliveredRoute
  AuthenticatedOrdersLayoutNewRoute: typeof AuthenticatedOrdersLayoutNewRoute
  AuthenticatedOrdersLayoutReadyRoute: typeof AuthenticatedOrdersLayoutReadyRoute
  AuthenticatedOrdersLayoutIndexRoute: typeof AuthenticatedOrdersLayoutIndexRoute
}

const AuthenticatedOrdersLayoutRouteChildren: AuthenticatedOrdersLayoutRouteChildren =
  {
    AuthenticatedOrdersLayoutDeliveredRoute:
      AuthenticatedOrdersLayoutDeliveredRoute,
    AuthenticatedOrdersLayoutNewRoute: AuthenticatedOrdersLayoutNewRoute,
    AuthenticatedOrdersLayoutReadyRoute: AuthenticatedOrdersLayoutReadyRoute,
    AuthenticatedOrdersLayoutIndexRoute: AuthenticatedOrdersLayoutIndexRoute,
  }

const AuthenticatedOrdersLayoutRouteWithChildren =
  AuthenticatedOrdersLayoutRoute._addFileChildren(
    AuthenticatedOrdersLayoutRouteChildren,
  )

interface AuthenticatedOrdersRouteChildren {
  AuthenticatedOrdersLayoutRoute: typeof AuthenticatedOrdersLayoutRouteWithChildren
}

const AuthenticatedOrdersRouteChildren: AuthenticatedOrdersRouteChildren = {
  AuthenticatedOrdersLayoutRoute: AuthenticatedOrdersLayoutRouteWithChildren,
}

const AuthenticatedOrdersRouteWithChildren =
  AuthenticatedOrdersRoute._addFileChildren(AuthenticatedOrdersRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDailymenuRoute: typeof AuthenticatedDailymenuRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrdersRoute: typeof AuthenticatedOrdersRouteWithChildren
  AuthenticatedItemsIndexRoute: typeof AuthenticatedItemsIndexRoute
  AuthenticatedItemsDetailIdRoute: typeof AuthenticatedItemsDetailIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDailymenuRoute: AuthenticatedDailymenuRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrdersRoute: AuthenticatedOrdersRouteWithChildren,
  AuthenticatedItemsIndexRoute: AuthenticatedItemsIndexRoute,
  AuthenticatedItemsDetailIdRoute: AuthenticatedItemsDetailIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedDailymenuRouteWithChildren
  '/login': typeof LoginRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/orders': typeof AuthenticatedOrdersLayoutRouteWithChildren
  '/items': typeof AuthenticatedItemsIndexRoute
  '/dailymenu/day': typeof AuthenticatedDailymenuDailymenuDayRoute
  '/dailymenu/new': typeof AuthenticatedDailymenuDailymenuNewRoute
  '/dailymenu/today': typeof AuthenticatedDailymenuDailymenuTodayRoute
  '/items/detail/$id': typeof AuthenticatedItemsDetailIdRoute
  '/orders/delivered': typeof AuthenticatedOrdersLayoutDeliveredRoute
  '/orders/new': typeof AuthenticatedOrdersLayoutNewRoute
  '/orders/ready': typeof AuthenticatedOrdersLayoutReadyRoute
  '/dailymenu': typeof AuthenticatedDailymenuDailymenuIndexRoute
  '/orders/': typeof AuthenticatedOrdersLayoutIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '': typeof AuthenticatedDailymenuRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/orders': typeof AuthenticatedOrdersLayoutIndexRoute
  '/items': typeof AuthenticatedItemsIndexRoute
  '/dailymenu/day': typeof AuthenticatedDailymenuDailymenuDayRoute
  '/dailymenu/new': typeof AuthenticatedDailymenuDailymenuNewRoute
  '/dailymenu/today': typeof AuthenticatedDailymenuDailymenuTodayRoute
  '/items/detail/$id': typeof AuthenticatedItemsDetailIdRoute
  '/orders/delivered': typeof AuthenticatedOrdersLayoutDeliveredRoute
  '/orders/new': typeof AuthenticatedOrdersLayoutNewRoute
  '/orders/ready': typeof AuthenticatedOrdersLayoutReadyRoute
  '/dailymenu': typeof AuthenticatedDailymenuDailymenuIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/_dailymenu': typeof AuthenticatedDailymenuRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/orders': typeof AuthenticatedOrdersRouteWithChildren
  '/_authenticated/orders/_layout': typeof AuthenticatedOrdersLayoutRouteWithChildren
  '/_authenticated/items/': typeof AuthenticatedItemsIndexRoute
  '/_authenticated/_dailymenu/dailymenu/day': typeof AuthenticatedDailymenuDailymenuDayRoute
  '/_authenticated/_dailymenu/dailymenu/new': typeof AuthenticatedDailymenuDailymenuNewRoute
  '/_authenticated/_dailymenu/dailymenu/today': typeof AuthenticatedDailymenuDailymenuTodayRoute
  '/_authenticated/items/detail/$id': typeof AuthenticatedItemsDetailIdRoute
  '/_authenticated/orders/_layout/delivered': typeof AuthenticatedOrdersLayoutDeliveredRoute
  '/_authenticated/orders/_layout/new': typeof AuthenticatedOrdersLayoutNewRoute
  '/_authenticated/orders/_layout/ready': typeof AuthenticatedOrdersLayoutReadyRoute
  '/_authenticated/_dailymenu/dailymenu/': typeof AuthenticatedDailymenuDailymenuIndexRoute
  '/_authenticated/orders/_layout/': typeof AuthenticatedOrdersLayoutIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/settings'
    | '/'
    | '/orders'
    | '/items'
    | '/dailymenu/day'
    | '/dailymenu/new'
    | '/dailymenu/today'
    | '/items/detail/$id'
    | '/orders/delivered'
    | '/orders/new'
    | '/orders/ready'
    | '/dailymenu'
    | '/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | ''
    | '/settings'
    | '/'
    | '/orders'
    | '/items'
    | '/dailymenu/day'
    | '/dailymenu/new'
    | '/dailymenu/today'
    | '/items/detail/$id'
    | '/orders/delivered'
    | '/orders/new'
    | '/orders/ready'
    | '/dailymenu'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/_dailymenu'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/orders'
    | '/_authenticated/orders/_layout'
    | '/_authenticated/items/'
    | '/_authenticated/_dailymenu/dailymenu/day'
    | '/_authenticated/_dailymenu/dailymenu/new'
    | '/_authenticated/_dailymenu/dailymenu/today'
    | '/_authenticated/items/detail/$id'
    | '/_authenticated/orders/_layout/delivered'
    | '/_authenticated/orders/_layout/new'
    | '/_authenticated/orders/_layout/ready'
    | '/_authenticated/_dailymenu/dailymenu/'
    | '/_authenticated/orders/_layout/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_dailymenu",
        "/_authenticated/settings",
        "/_authenticated/",
        "/_authenticated/orders",
        "/_authenticated/items/",
        "/_authenticated/items/detail/$id"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_authenticated/_dailymenu": {
      "filePath": "_authenticated/_dailymenu.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_dailymenu/dailymenu/day",
        "/_authenticated/_dailymenu/dailymenu/new",
        "/_authenticated/_dailymenu/dailymenu/today",
        "/_authenticated/_dailymenu/dailymenu/"
      ]
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/orders": {
      "filePath": "_authenticated/orders",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/orders/_layout"
      ]
    },
    "/_authenticated/orders/_layout": {
      "filePath": "_authenticated/orders/_layout.tsx",
      "parent": "/_authenticated/orders",
      "children": [
        "/_authenticated/orders/_layout/delivered",
        "/_authenticated/orders/_layout/new",
        "/_authenticated/orders/_layout/ready",
        "/_authenticated/orders/_layout/"
      ]
    },
    "/_authenticated/items/": {
      "filePath": "_authenticated/items/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_dailymenu/dailymenu/day": {
      "filePath": "_authenticated/_dailymenu/dailymenu/day.tsx",
      "parent": "/_authenticated/_dailymenu"
    },
    "/_authenticated/_dailymenu/dailymenu/new": {
      "filePath": "_authenticated/_dailymenu/dailymenu/new.tsx",
      "parent": "/_authenticated/_dailymenu"
    },
    "/_authenticated/_dailymenu/dailymenu/today": {
      "filePath": "_authenticated/_dailymenu/dailymenu/today.tsx",
      "parent": "/_authenticated/_dailymenu"
    },
    "/_authenticated/items/detail/$id": {
      "filePath": "_authenticated/items/detail/$id.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/orders/_layout/delivered": {
      "filePath": "_authenticated/orders/_layout/delivered.tsx",
      "parent": "/_authenticated/orders/_layout"
    },
    "/_authenticated/orders/_layout/new": {
      "filePath": "_authenticated/orders/_layout/new.tsx",
      "parent": "/_authenticated/orders/_layout"
    },
    "/_authenticated/orders/_layout/ready": {
      "filePath": "_authenticated/orders/_layout/ready.tsx",
      "parent": "/_authenticated/orders/_layout"
    },
    "/_authenticated/_dailymenu/dailymenu/": {
      "filePath": "_authenticated/_dailymenu/dailymenu/index.tsx",
      "parent": "/_authenticated/_dailymenu"
    },
    "/_authenticated/orders/_layout/": {
      "filePath": "_authenticated/orders/_layout/index.tsx",
      "parent": "/_authenticated/orders/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
